import {Route, Switch, Redirect} from 'react-router-dom'
import Map from './page/map/Index'
import Station from './page/station/Index'
import Compare from './page/compare/Index'
import Register from './page/register/Index'
import Faq from './page/faq/Index'
import DashBoard from './page/dashboard/Index'
import Profile from './page/profile/Index'
import WaitingForApprove from './page/waiting-for-approve/Index'
import Contact from './page/contact/Index'
import Error404 from './page/404/Index'
import MgtStationListALl from './page/mgt-station-all/Index'
import MgtSensorListALl from './page/mgt-sensor-all/Index'
import MgtUsers from './page/mgt-user/Index'
import MgtOrg from './page/mgt-org/Index'
import MgtUserPermissions from './page/mgt-permission/Index'
import MgtStation from './page/mgt-station/Index'
import MgtSensorData from './page/mgt-sensor-data/Index'
import MgtSensor from './page/mgt-sensor/Index'
import ForgetPassword from './page/forget-password/Index'
import ResetPassword from './page/reset-password/Index'


export default function Routes() {
    const routeLists = [
      {path: "/404", exact: true, component: Error404},
      {path: "/", exact: true, component: Map},
      {path: "/map", exact: true, component: Map},
      {path: "/compare-graph", exact: true, component: Compare},
      {path: "/stations", exact: true, component: Station},
      {path: "/stations/:stationId", exact: true, component: Station},
      {path: "/register", exact: true, component: Register},
      {path: "/faq", exact: true, component: Faq},

      {path: "/forget-password", exact: true, component: ForgetPassword},
      {path: "/reset-password/:token", exact: true, component: ResetPassword},

      {path: "/waiting-for-approve", exact: true, component: WaitingForApprove},
      {path: "/dashboard", exact: true, component: DashBoard},
      {path: "/profile", exact: true, component: Profile},
      {path: "/mgt-station", exact: true, component: MgtStationListALl},
      {path: "/mgt-station/create", exact: true, component: MgtStation},
      {path: "/mgt-station/:stationId", exact: true, component: MgtStation},
      {path: "/mgt-sensor", exact: true, component: MgtSensorListALl},
      {path: "/mgt-sensor/create", exact: true, component: MgtSensor},
      {path: "/mgt-sensor/:sensorId", exact: true, component: MgtSensor},
      {path: "/mgt-user", exact: true, component: MgtUsers},
      {path: "/mgt-org", exact: true, component: MgtOrg},
      {path: "/mgt-permission", exact: true, component: MgtUserPermissions},
      {path: "/mgt-sensor-data", exact: true, component: MgtSensorData},
    ]

    return (
        <Switch>
          {routeLists.map((route, index) =>{
            return <Route key={route.path} path={route.path} exact={route.exact} component={route.component}></Route>
        })}
        <Redirect to="/404" />
        </Switch>
    )
}
